import { Typography } from 'antd';
import { FC } from 'react';
import styled from 'styled-components';

const { Text } = Typography;

export const Header: FC = () => {
  return (
    <Wrapper>
      <Text
        style={{
          fontWeight: 600,
          fontSize: '24px',
          color: '#FFFFFFD9',
        }}
      >
        Bem vindo!
      </Text>
      <Text
        style={{
          fontWeight: 400,
          fontSize: '14px',
          color: '#FFFFFF73',
        }}
      >
        Consulte dados da sua base de clientes e gerencie todo o conteúdo e
        recursos da plataforma.
      </Text>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  gap: 8px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
